import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import PolicyIcon from '@mui/icons-material/Policy';

import { Link, Navigate, Route, useNavigate } from 'react-router-dom'
import Mail from '@mui/icons-material/Mail';
import HomeIcon from '@mui/icons-material/Home';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

import { Avatar, Button } from '@mui/material';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import logo from "../Images/iconoapp.png"
import Cubo3x3Icon from '../Images/cubo3x3normal.svg'
import DescargarApp from './DescargarApp';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

/*
{ titulo: 'Cr-Single', icono: <PeopleAltIcon />, ref: "/cr-single/" },
  { titulo: 'Cr-Average', icono: <PeopleAltIcon />, ref: "/cr-average/" },
*/
export default function MenuDrawerApp(props) {
  const menuAplicacion = [{ titulo: 'Inicio', icono: <HomeIcon />, ref: "/" },
  { titulo: 'Torneos', icono: <EmojiEventsIcon />, ref: "/t/" },
  ];

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  //const navegar = useNavigate();


  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{
      height: '100vh',
      display: "flex",
      flexDirection: "row"
    }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Avatar alt="Remy Sharp" src={logo} component={Link} to={"/"}/>
          <Typography variant="h6" noWrap component="div" sx={{ ml: 1, flexGrow: 1 }}>
            JChess Manager
          </Typography>
          
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {menuAplicacion.map((dato, index) => (
            <ListItem key={dato.titulo} disablePadding sx={{ display: 'block' }}>
              <ListItemButton component={Link} to={dato.ref}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  {dato.icono}
                </ListItemIcon>
                <ListItemText primary={dato.titulo} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>

          {
            //{ titulo: 'Patrones', icono: <Cubo3x3Icon/>, ref: "/patrones/" },
            /*[{ titulo: 'Patrones', icono: Cubo3x3Icon, ref: "/patrones/" }].map((dato, index) => (
              <ListItem key={dato.titulo} disablePadding sx={{ display: 'block' }}>
                <ListItemButton component={Link} to={dato.ref}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <Avatar src={dato.icono} sx={{ p: 1, bgcolor: 'grey' }}></Avatar>
                  </ListItemIcon>
                  <ListItemText primary={dato.titulo} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </ListItem>

            ))*/

          }

          {[{ titulo: 'Políticas', icono: <PolicyIcon />, ref: "/politicas/" }].map((dato, index) => (
            <ListItem key={dato.titulo} disablePadding sx={{ display: 'block' }}>
              <ListItemButton component={Link} to={dato.ref}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  {dato.icono}
                </ListItemIcon>
                <ListItemText primary={dato.titulo} sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>

          ))}
        </List>
      </Drawer>
      <Box component="main"
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        }}>
        <DrawerHeader />
        <Box sx={{ p: 2 }}>
          {props.contenido}
        </Box>
      </Box>
    </Box>
  );
}

/*<Button variant="outlined" startIcon={<CloudDownloadIcon />} color="inherit" onClick={abrirAppFuera}>
            Descargar
          </Button> */